import { selectors as userSelectors } from 'ducks/user';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { branch, compose, renderComponent } from 'recompose';
import { createSelector } from 'reselect';
import getUserAbility from 'selectors/getUserAbility';
import getMarketingUrl from 'selectors/getMarketingUrl';
import DashboardIntro from './../components/DashboardIntro';
import UserLists from './../components/UserLists';

const isPopulated = R.both(
  R.complement(R.isNil),
  R.complement(R.isEmpty),
);

const getHasSetRatings = R.pipe(
  userSelectors.preferences,
  R.propOr({}, 'dashboardRatings'),
  R.either(
    R.pipe(
      R.prop('countries'),
      isPopulated,
    ),
    R.pipe(
      R.prop('riskTypes'),
      isPopulated,
    ),
  ),
);

const getHasSetAlerts = R.pipe(
  userSelectors.preferences,
  R.propOr({}, 'dashboardAlerts'),
  R.either(
    R.pipe(
      R.prop('riskTypes'),
      isPopulated,
    ),
    R.pipe(
      R.prop('geographies'),
      isPopulated,
    ),
  ),
);

const getHasSetArticles = R.pipe(
  userSelectors.preferences,
  R.propOr({}, 'dashboardArticles'),
  R.pipe(
    R.prop('regions'),
    isPopulated,
  ),
);

const getHasPreferences = createSelector(
  getHasSetAlerts,
  getHasSetArticles,
  getHasSetRatings,
  (...prefs) => prefs.some(pref => pref === true),
);

/**
 * Renders either pref-specific lists of entities, or a welcome message if
 * no preferences have been set.
 * @type {React.ComponentClass<any>}
 */
const UserContent = compose(
  connect(R.applySpec({
    hasPreferences: getHasPreferences,
    hasSetRatings: getHasSetRatings,
    hasSetAlerts: getHasSetAlerts,
    hasSetArticles: getHasSetArticles,
    ability: getUserAbility,
    marketingUrl: getMarketingUrl,
  })),
  branch(
    R.either(
      R.propEq('hasPreferences', false),
      /**
       * Check if user can update dashboard, since it's possible to have a sub,
       * set preferences then lose your subscription.
       */
      ({ ability }) => ability.cannot('update', 'Dashboard'),
    ),
    renderComponent(DashboardIntro),
  ),
)(UserLists);

export default UserContent;

